import {
  ChangeDetectorRef,
  Component,
  Inject,
  ViewEncapsulation,
  DOCUMENT
} from '@angular/core';


@Component({
    selector: 'content',
    templateUrl: './content.component.html',
    encapsulation: ViewEncapsulation.None,
    styles: [`
    .route-fade-wrapper {
      opacity: 1;
    }

    .route-fade-wrapper.route-fade-active {
      animation: routeFadeIn 500ms ease;
    }

    @keyframes routeFadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
  `],
    standalone: false
})
export class ContentComponent {
  public isRouteAnimating = false;
  /**
   * Constructor
   *
   *
   * @param _document
   * @param changeDetectorRef
   */
  constructor(
    @Inject(DOCUMENT) private _document: Document,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {}

  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit(): void {}

  onActivate(event) {
    this.isRouteAnimating = false;
    setTimeout(() => {
      this.isRouteAnimating = true;
    });
    if (this._document?.querySelector('.menu-navs')) {
      this._document.querySelector('.menu-navs').classList.remove('active');
    }
  }
}
